/**
 * @desc 财务画像-基础信息-财务总览
 */
import React, { PureComponent } from 'react';
import IndustryAnalysis from './IndustryAnalysis';
import CompanyFinancial from './CompanyFinancial';
import BusinessChange from './BusinessChange';

export default class Financial extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tableData: []
        };
    }

    render() {
        return (
            <div>
                <IndustryAnalysis />
                <CompanyFinancial />
                <BusinessChange />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/baseInfo/financial/Financial.jsx